import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'display',
    `
		position: relative;
		width: 155px;
		margin-bottom: 10px;
	`
  ],
  [
    'calendarIcon',
    `
		position: absolute;
		top: 8px;
		right: 5px;
	`
  ]
]);
